// extracted by mini-css-extract-plugin
export var backdropBlur = "_k1-0";
export var contentCard = "_k1-5";
export var frame = "_k1-2";
export var image = "_k1-4";
export var imagePane = "_k1-3";
export var modal = "_k1-1";